import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class PropertyService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getProperty(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/property/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getPropertyReplace(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/property/?' + gridData.toString())
      .pipe(map(rsp => rsp['data']), catchError(res => this.helper.catchError(res)));
  }

  public getPropertyItem(propertyId, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/property/' + propertyId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getProductProperty(productId, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/property/products/' + productId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageProperty(property, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/property/' + id, property)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/property/', property)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public softDeleteProperty(id) {
    return this.http.delete(environment.apiUrl + '/backoffice/property/' + id )
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public reAdd(id) {
    return this.http.put(environment.apiUrl + '/backoffice/property/' + id + '/re-add', {id: id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
